import Component from '../abstracts/Component';

export default class CarouselComponent extends Component {

  get SELECTORS() {
    return {
      main: '[data-carousel="true"]',
      lookBookCurrent: '.js-lookbook-current-slide',
      currentNumberedSlide: '.js-current-number-slide',
      carouselFader: '.carousel-fader'
    };
  }

  constructor() {
    super();
    this.main = $(this.SELECTORS.main);
    this.whatchRes = [];
  }

  importLibrary() {

    this.moduleLoader.loadCarouselAndExecute(
      (module) => {
        this.initCarousels();
        this.bindEvents();
      },
      (error) => {
        console.error("failed to load slick ", error.stack);
      }
    )
  }

  initLookbookCarousel(carousel) {

    $(carousel).slick({
      dots: true,
      slidesToShow: 3,
      slidesToScroll: 3,
      centerMode: false,
      arrows: true,
      customPaging : function(slider, i) {
        return `${i < 9 ? '0' : ''}${i + 1}`;
      },
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false,
            centerMode: false,
            arrows: true
          }
        }
      ]
    });

    if (this.$matchMedia('sm')) {
      const lookBookCurrentSlide = document.querySelector(this.SELECTORS.currentNumberedSlide);
      lookBookCurrentSlide.innerHTML = $(carousel).slick('slickCurrentSlide') + 1;
      $(carousel).on('afterChange', (e, slick, currentSlide) => {
        lookBookCurrentSlide.innerHTML = currentSlide + 1;
      })
    }

    $(carousel).on('afterChange', (e, slick, currentSlide) => {
      let visibleMarkers = document.querySelectorAll('.js-lookbook-image.markers-visible');
      visibleMarkers.forEach( visibleMarker => {
        let activeMarker = visibleMarker.querySelector('.js-marker')
        activeMarker.click();
      });
    })
  }

  initCartCarousels(carousel) {
    // check
    if ($(carousel).length === 0 ) return false;
    // if is the new page
    if (document.querySelector('.cart-container') !== null) {
      // benefit bar carousel:
      if (carousel.classList.contains('benefit-bar-slider')) {
        $(carousel).slick();
      } else {
        carousel.dataset.slick = '';
        $(carousel).slick({
          dots: false,
          slidesToShow: 4,
          slidesToScroll: 1,
          centerMode: false,
          arrows: true,
          infinite: true,
          centerPadding: '40px',
          responsive: [
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                dots: false,
                centerMode: true,
                arrows: false,
                centerPadding: '20px'
              }
            },
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                dots: false,
                centerMode: true,
                arrows: true,
                infinite: true,
                centerPadding: 0
              }
            }
          ]
        });

      }
    } else {
      // fallback to normal cart
      $(carousel).slick();
    }
  }

  initCheckoutConfirmCarousels(carousel) {
    // check
    if ($(carousel).length === 0 ) return false;
    // if is the new page
    if (document.querySelector('.checkout-thankyou') !== null) {
      // benefit bar carousel:
      if (carousel.classList.contains('benefit-bar-slider')) {
        $(carousel).slick();
      } else {
        // return false;
        carousel.dataset.slick = '';
        $(carousel).slick({
          dots: false,
          slidesToShow: 5,
          slidesToScroll: 1,
          centerMode: false,
          arrows: true,
          infinite: true,
          responsive: [
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                dots: false,
                centerMode: true,
                arrows: false,
                centerPadding: '20px'
              }
            }
          ]
        });

      }
    } else {
      // fallback to normal cart
      $(carousel).slick();
    }
  }

  initQuickCatCarousels(carousel) {
    // check
    if ($(carousel).length === 0 ) return false;
    // go carousel
    $(carousel).slick({
      dots: true,
      slidesToShow: 2,
      slidesToScroll: 1,
      centerMode: false,
      arrows: true,
      infinite: true,
    });
  }

  initCarousels() {

    let carousels = document.querySelectorAll(this.SELECTORS.main);

    carousels.forEach(carousel => {
      const maxRes = carousel.dataset.carouselMaxres ? carousel.dataset.carouselMaxres : false;
      const matchMedia = maxRes ? this.$matchMedia(carousel.dataset.carouselMaxres, null) : false;
      const carouselFader = carousel.parentElement.querySelector(this.SELECTORS.carouselFader);

      if (maxRes && matchMedia || !maxRes && !matchMedia) {
        if (carousel.classList.contains('lookbook-carousel') && !carousel.classList.contains('slick-initialized')) {
          this.initLookbookCarousel(carousel);
        } else if ( (document.body.classList.contains('t-cart')) && !carousel.classList.contains('slick-initialized')) {
          this.initCartCarousels(carousel);
        } else if ( document.body.classList.contains('t-checkout-confirm') && !carousel.classList.contains('slick-initialized')) {
          this.initCheckoutConfirmCarousels(carousel);
        } else if ( carousel.classList.contains('quick-category-cro-carousel') && !carousel.classList.contains('slick-initialized')) {
          this.initQuickCatCarousels(carousel);
        } else if (!carousel.classList.contains('slick-initialized') && !carousel.classList.contains('c-lookbook') && !document.body.classList.contains('t-cart')) {
          $(carousel).slick();
        }

        if (carousel.dataset.carouselNumbered) {
          const currentSlideNumberContainer = carousel.parentElement.querySelector(this.SELECTORS.currentNumberedSlide);
          currentSlideNumberContainer.innerHTML = $(carousel).slick('slickCurrentSlide') + 1;

          $(carousel).on('afterChange', (e, slick, currentSlide) => {
            currentSlideNumberContainer.innerHTML = currentSlide + 1;
          })
        }

      } else if (maxRes && !matchMedia) {
        this.whatchRes.push(carousel);
      }

      if (carouselFader) {
        let thisSlide = {
          number: $(carousel).slick('slickCurrentSlide') + 1,
          element: carousel.querySelector('.slick-active')
        };

        $(carousel).on('swipe', (e) => {
          thisSlide.number = e.currentTarget.slick.currentSlide + 1;
        })

        $(carousel).on('afterChange', (e, slick, currentSlide) => {
          thisSlide.number = currentSlide + 1;
        })
      }

      if ($(carousel).attr('data-carousel-start')) {
        $(carousel).slick('slickGoTo', $(carousel).attr('data-carousel-start') - 1)
      }
    });
  }

  bindEvents() {
    this.$on('resize.carousel', () => {
      this.whatchRes.forEach(carousel => {
        const matchMedia = this.$matchMedia(carousel.dataset.carouselMaxres);
        const alreadyInit = carousel.classList.contains('slick-initialized');
        if (matchMedia && !alreadyInit) {
          if (carousel.classList.contains('lookbook-carousel')) {
            this.initLookbookCarousel(carousel);
          } else {
            $(carousel).slick();
          }
          if (carousel.dataset.carouselNumbered) {
            const currentSlideNumberContainer = document.querySelector(this.SELECTORS.currentNumberedSlide);
            currentSlideNumberContainer.innerHTML = $(carousel).slick('slickCurrentSlide') + 1;
            $(carousel).on('afterChange', (e, slick, currentSlide) => {
              currentSlideNumberContainer.innerHTML = currentSlide + 1;
            })
          }
        } else if (!matchMedia && alreadyInit) {
          $(carousel).slick('unslick');
        }
      });
    });
  }

  render() {
    if (document.querySelectorAll(this.SELECTORS.main)) this.importLibrary();

    this.$on(this.$customEvents.MODAL_EVENTS.afterOpen, () => {
      if ($('.vex').find('[data-carousel="true"]').length > 0) this.initCarousels();
    });

    this.$on(this.$customEvents.RETURN_EVENTS.subsituteProduct, () => {
      if (document.querySelectorAll(this.SELECTORS.main)) this.initCarousels();
    });

  }
}
